import { render, staticRenderFns } from "./RestaurantsList.vue?vue&type=template&id=0b978ad5&"
import script from "./RestaurantsList.vue?vue&type=script&lang=js&"
export * from "./RestaurantsList.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports